import {make} from "vuex-pathify";

const state = {
    premises: [],
    groups: [],
    organizations: [],
    premisesPage: 1,
    premisesTotalRows: 0,
    premisesFilters: {
        name: '',
        groupName: ''
    }
}

const mutations = {
    ...make.mutations(state),
}

const actions = {
    ...make.actions(state),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
